import {isBoolean} from "lodash/lang";
import {
    addEstate,
    addListing,
    createFavoritesStorage,
    emptyFavorites,
    removeEstate,
    removeListing,
} from "./favoritesStorage";

const namespaced = true

const storage = createFavoritesStorage(window.localStorage)

const state = {
    isLoaded: false,
    favoritesIds: emptyFavorites()
}

const getters = {
    isLoaded: (state) => state.isLoaded,
    favoritesIds: (state) => state.favoritesIds,
    listingKeys: (state) => state.favoritesIds.listings,
}

const mutations = {
    index: (state, payload) => {
        if (payload && typeof payload === 'object') {
            state.favoritesIds = payload;
        }
    },
    setIsLoaded: (state, payload) => {
        isBoolean(payload) && (state.isLoaded = payload)
    }
}

const trackAdded = () => {
    if (window.sendEvent) {
        sendEvent('key_click_favorite_com', {})
    }
}

const estateKind = (params) => params.isComplex ? 'complexes' : 'properties'

const actions = {
    index: async ({ commit, state }) => {
        try {
            commit('setIsLoaded', false)
            // Written back in the current shape: a value saved before MLS
            // favorites existed gains an empty `listings` and keeps the rest.
            commit('index', storage.update((favorites) => favorites))
            commit('setIsLoaded', true)
            return state.favoritesIds
        } catch (e) {
            console.error(e)
        }
    },

    /** Another tab changed the value: take it as is, write nothing back. */
    sync: ({ commit }) => {
        commit('index', storage.read())
    },

    store: async ({ commit, dispatch }, params) => {
        try {
            if (storage.read()[estateKind(params)].includes(params.id)) {
                return await dispatch('delete', params)
            }

            commit('index', storage.update((favorites) => addEstate(favorites, estateKind(params), params.id)))
            trackAdded()
            return {
                message: 'Недвижимость успешно добавлена в "избранное"'
            }
        } catch (e) {
            console.error(e)
        }
    },

    delete: async ({ commit }, params) => {
        try {
            commit('index', storage.update((favorites) => removeEstate(favorites, estateKind(params), params.id)))
            return {
                message: 'Недвижимость успешно удалена из "избранное"'
            }
        } catch (e) {
            console.error(e)
        }
    },

    /** Returns whether the listing is saved after the click. */
    toggleListing: ({ commit }, key) => {
        let added = false

        commit('index', storage.update((favorites) => {
            if (favorites.listings.includes(key)) {
                return removeListing(favorites, key)
            }

            added = true
            return addListing(favorites, key)
        }))

        if (added) {
            trackAdded()
        }

        return added
    },

    removeListing: ({ commit }, key) => {
        commit('index', storage.update((favorites) => removeListing(favorites, key)))
    },

    /**
     * Clears all three lists. `keepListings` leaves the MLS keys alone — for a
     * page that does not show them and so must not throw them away.
     */
    deleteAll: async ({ commit }, { keepListings = false } = {}) => {
        try {
            commit('index', storage.update((favorites) => ({
                ...emptyFavorites(),
                listings: keepListings ? favorites.listings : [],
            })))
            return {
                message: 'Вся недвижимость успешно удалена из "избранное"'
            }
        } catch (e) {
            console.error(e)
        }
    }
}

export default {
    mutations,
    actions,
    state,
    getters,
    namespaced,
}
